export const API_ERROR_MESSAGE_4XX =
  'Permission Mismatch. If the problem persists please email support@centerline.co.';

export const API_ERROR_MESSAGE_5XX =
  'Error communicating with server. If the problem persists please email support@centerline.co.';
